export default () => document.querySelector('body').classList.contains('is-our-app');
